angular.module('rjmNg.common.api').factory 'phpServiceUrl', [
  "siteRoot"
  (siteRoot) ->
    (url) ->
      return "#{siteRoot}/v2#{url}"
]
